export const SET_NOTIF_LIST = "adminNotice/SET_NOTIF_LIST";
export const DELETE_NOTIF = "adminNotice/DELETE_NOTIF";
export const INSERT_NOTIF = "adminNotice/INSERT_NOTIF";
export const UPDATE_NOTIF = "adminNotice/UPDATE_NOTIF";
export const GET_NOTIF = "adminNotice/GET_NOTIF";